import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaintenanceService } from './feature/maintenance/services/maintenance.service';
import { SharedModule } from './shared/shared.module';
import { AnalyticsInitService } from './shared/services/analytics-init.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SharedModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  maintenanceStatus: boolean = false;
  loading: boolean = true;

  constructor(
    private readonly maintencanceService: MaintenanceService,
    private readonly analyticsInitService: AnalyticsInitService,
  ) {
    this.maintencanceService
      .checkMaintenanceStatus()
      .subscribe((isMaintenance) => {
        this.maintenanceStatus = isMaintenance;
        this.loading = false;
      });
  }

  ngOnInit() {
    this.analyticsInitService.initializeAnalytics();
  }
}
